import { StateV1, StateV2 } from './2_migrate_produktauswahl_warenkorb.interfaces';

export const migrateToProduktauswahlAndWarenkorb = (
  previousState: StateV1,
  newVersion: number,
): StateV2 => {
  const produktauswahl: StateV2['produktauswahl'] = previousState.produkte
    .filter(produkt => produkt.selectable)
    .map(produkt => ({
      appId: produkt.produktId,
      dashboardIcon: produkt.dashboardIcon,
      produktKdvId: produkt.produktKdvId,
      title: produkt.title,
      uebersichtTitle: produkt.uebersichtTitle,
    }));
  const warenkorb: StateV2['warenkorb'] = previousState.produkte
    .filter(produkt => produkt.isSelected)
    .map(produkt => {
      return {
        produktId: produkt.produktId,
        angebotsId: produkt.angebotsId,
        kurztext: produkt.kurztext,
        uebersichtTitle: produkt.uebersichtTitle,
        dashboardIcon: produkt.dashboardIcon,
        produktKdvId: produkt.produktKdvId,
        ausgewaehlteLinie: produkt.ausgewaehlteLinie,
        versichertesRisiko: produkt.versichertesRisiko,
        bruttopreis: produkt.bruttopreis,
        bruttopreisOhneKombiRabatt: produkt.bruttopreisOhneKombiRabatt,
        laufzeit: produkt.laufzeit,
        rbd: produkt.rbd,
        rbd_max: produkt.rbd_max,
        treuebonus: produkt.treuebonus,
        rabattstufe: produkt.rabattstufe,
        isZaehlstueck: produkt.isZaehlstueck,
        selectedZusatzoptionen: produkt.selectedZusatzoptionen,
        sofortschutzAvailable: produkt.sofortschutzAvailable,
        vorvertragsNummern: produkt.vorvertragsNummern,
      };
    });
  return {
    ...previousState,
    version: newVersion,
    produkte: null,
    produktauswahl,
    warenkorb,
  };
};
